import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLicenseCrmModules} from 'src/openapi/admin/apis/GetLicenseCrmModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseCrmModules} from './services/dictionary-slice';

export const useLicenseCrmModules = () => {
    const apiDispatch = useAppDispatch();
    const licenseCrmModules = useSelector(selectLicenseCrmModules);

    const loadLicenseCrmModules = useCallback(() => {
        if (!licenseCrmModules.length) {
            apiDispatch(getLicenseCrmModules());
        }
    }, [licenseCrmModules.length, apiDispatch]);

    return {licenseCrmModules, loadLicenseCrmModules};
};
